import {useIsWeb} from '@eCommerce/frontend-legacy-shared-library-native';
import {View, Text} from 'native-base';
import React from 'react';
import FA5ProIcon from 'react-native-vector-icons/FontAwesome5Pro';
import InnerCircleText from '../InnerCircleText/InnerCircleText';
import {useTheme} from 'styled-components/native';

export const SEVEN_STARS_EXPERIENCE_CREDIT_COST = 250000;

export const getSevenStarsExperienceCreditCount = (tierCredits: number) =>
  Math.floor(Math.max(0, tierCredits) / SEVEN_STARS_EXPERIENCE_CREDIT_COST);

export const getSevenStarsExperienceProgress = (tierCredits: number) =>
  (Math.max(0, tierCredits) % SEVEN_STARS_EXPERIENCE_CREDIT_COST) /
  SEVEN_STARS_EXPERIENCE_CREDIT_COST;

/**
 * Credits still needed for the next Experience Credit. Landing exactly on a
 * multiple starts the following cycle, so it reports a full cycle, never zero.
 */
export const getCreditsToNextExperienceCredit = (tierCredits: number) =>
  SEVEN_STARS_EXPERIENCE_CREDIT_COST -
  (Math.max(0, tierCredits) % SEVEN_STARS_EXPERIENCE_CREDIT_COST);

export interface SevenStarsInnerCircleProps {
  tierCredits: number;
}

const SevenStarsInnerCircle: React.FC<SevenStarsInnerCircleProps> = ({
  tierCredits,
}) => {
  const theme = useTheme() as any;
  const {white} = theme.colors;
  const isWeb = useIsWeb();
  const experienceCreditCount = getSevenStarsExperienceCreditCount(tierCredits);
  const oneCreditOrLess = tierCredits < SEVEN_STARS_EXPERIENCE_CREDIT_COST * 2;

  return (
    <View alignItems="center" justifyContent="center">
      <View justifyContent="center" alignItems="center" mb="8px">
        <FA5ProIcon size={40} color={white} name="shield" solid />
        <View position="absolute">
          <Text
            fontFamily="heading"
            fontWeight="bold"
            fontSize="14px"
            lineHeight={isWeb ? '18px' : undefined}
            color="#6E0C1D">
            {experienceCreditCount}
          </Text>
        </View>
      </View>
      <InnerCircleText text="Experience" isSevenStars={true} />
      <InnerCircleText
        text={`Credit${oneCreditOrLess ? '' : 's'}`}
        isSevenStars={true}
      />
    </View>
  );
};

export default SevenStarsInnerCircle;
